interface Props {
  readonly introductionText?: string;
  readonly subText?: string;
}

const OffersPageText = ({ introductionText, subText }: Props) => {
  if (!introductionText && !subText) return null;

  return (
    <section
      className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-testid="CT-143-Offers-Page-Text"
    >
      <div className="container flex flex-col gap-y-5 lg:grid lg:grid-cols-12 lg:gap-y-7.5">
        {introductionText && (
          <p
            className="h4 lg:col-span-8"
            data-testid="CT-143-Offers-Page-Text-Introduction"
          >
            {introductionText}
          </p>
        )}
        {subText && (
          <p
            className="body-one text-grey-600 lg:col-span-7 dark:text-grey-200"
            data-testid="CT-143-Offers-Page-Text-Subtext"
          >
            {subText}
          </p>
        )}
      </div>
    </section>
  );
};

export default OffersPageText;
